import { atom } from 'jotai';

export const hasCouponCodesFileState = atom<boolean>(false);
